import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { STUDY_STATUS_MESSAGES } from '../../studies/helpers/status-helper';

@Directive({
  selector: '[dashboardStatusBadgeColor]',
})
export class StatusBadgeColorDirective implements AfterViewInit {
  @Input() status = '';

  constructor(private element: ElementRef) {}

  ngAfterViewInit() {
    if (!this.status) {
      return;
    }

    let opacity;
    let statusMessage;

    if (this.status.includes(STUDY_STATUS_MESSAGES.RUNNING)) {
      opacity = 1;
    } else if (this.status.includes(STUDY_STATUS_MESSAGES.FINISHED)) {
      opacity = 0.5;
    } else {
      opacity = 0.7;
    }

    statusMessage = this.status;

    this.element.nativeElement.style.backgroundColor = '#40434E';
    this.element.nativeElement.style.opacity = opacity;
    this.element.nativeElement.style.color = 'white';
    this.element.nativeElement.innerHTML = statusMessage;

    this.element.nativeElement.style.padding = '4px 6px';
    this.element.nativeElement.style.borderRadius = '4px';
  }
}
